import { useEffect, useState } from 'react';

/** Resolves once web fonts have loaded, so ScrollTrigger measures final line heights. */
export function useFontsReady(): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const done = () => {
      if (!cancelled) setReady(true);
    };
    if ('fonts' in document) {
      document.fonts.ready.then(done, done);
    } else {
      done();
    }
    return () => {
      cancelled = true;
    };
  }, []);

  return ready;
}
